import * as React from "react";

import Module from "./Card";
import EmptyPage from "../../components/EmptyPage";

import { TFrontModule } from "services/page/app";
import { TPlayground, TModule } from "services/page/admin";
import { ParseProductTagFromUrlResp } from "utils/playground/url";
import { RuntimeProps } from "../../../index";

interface MobileProps {
	id?: string;
	modules: TModule[];
	page: TPlayground;
	tagQuery: ParseProductTagFromUrlResp;
	runtime: RuntimeProps;
}
interface MobileState {
	moduleList: TFrontModule[];
	hasTitle?: boolean; // admin是否配置了pageTitle，app中默认不显示pageTitle
	pageDisabled: boolean;
	activityId: string;
}

/**
 * （1）是否有title(在app中默认灭有title)
 * （2）是否在App中
 *  (3)是否有nav
 *
 * nav 默认不会吸顶，product的tab默认吸顶
 *
 * 用到锚点定位的地方；nav的点击、nav组件中滚动的时候，需要同步高亮对应的tab、magic banner中配置内链、
 *
 * 锚点相关测试点：有无title、nav和magicbanner的定位、product模块吸顶，切换tab是否滚动到最顶部
 *
 */
class MegatronFrontForMobile extends React.Component<MobileProps, MobileState> {
	constructor(props: MobileProps) {
		super(props);

		if (props.page) {
			const { modules = [], page } = this.props;
			this.state = {
				moduleList: modules,
				pageDisabled: page && page.isDisable,
				activityId: page && page.groupId,
			};
			return;
		}

		this.state = {
			moduleList: null,
			pageDisabled: false,
			activityId: "",
		};
	}

	render() {
		const { moduleList, pageDisabled } = this.state;
		if (!moduleList) {
			return (
				<img
					src="https://i.ezbuy.sg/FgAEgY5gvRxBHePwb0J__mv_R_rB"
					style={{ width: "100%" }}
				/>
			);
		}
		if (!moduleList) {
			return null;
		}
		if ((moduleList && moduleList.length === 0) || pageDisabled) {
			return <EmptyPage />;
		}
		const { modules = [], page, runtime } = this.props;
		return (
			<React.Fragment>
				{modules.map((item: TModule, i: number) => {
					return (
						<Module
							key={i}
							index={i}
							positionId={item.header?.position}
							pageId={page?.id}
							activityId={page?.groupId}
							moduleDetail={item}
							stickToTop={0}
							runtime={runtime}
						/>
					);
				})}
			</React.Fragment>
		);
	}
}

export default MegatronFrontForMobile;
